import { Injectable } from '@angular/core';
import { BroadcasterService } from '@core/broadcaster/broadcaster.service';

@Injectable()
export class KngActivityIndicatorService {

  constructor(private broadcaster: BroadcasterService) { }

  show() {
    this.broadcaster.broadcast('kng-activity-indicator.open');
  }

  close() {
    this.broadcaster.broadcast('kng-activity-indicator.close');
  }

}



// WEBPACK FOOTER //
// D:/dclean-web-latest/cot-web/src/app/layout/kingswell/services/kngActivityIndicator.service.ts